module.exports = __webpack_public_path__ + "assets/images/carSeat-04.37b107cd25b9e0de99838e5826692d6f.svg";